<!--  -->
<template>
  <div class="login-wrapper" v-if="showDialog">
    <el-dialog title="修改密码" width="540px" :visible="true" @close="closeFn">
      <el-form
        ref="form"
        :model="formData"
        :rules="formRules"
        label-position="right"
        label-width="150px"
      >
        <!-- <el-form-item label="用户名">
          <el-input disabled v-model="userInfo.username"></el-input>
        </el-form-item>-->
        <el-form-item label="旧密码" prop="oldPassWord">
          <el-input :show-password="true" v-model="formData.oldPassWord" placeholder="请输入新的密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassWord">
          <el-input :show-password="true" v-model="formData.newPassWord" placeholder="请输入新的密码"></el-input>
        </el-form-item>
        <el-form-item label="再次确认密码" prop="confirmPassWord">
          <el-input :show-password="true" v-model="formData.confirmPassWord" placeholder="请输入新的密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeFn">取 消</el-button>
        <el-button type="primary" @click="editPassword">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { changePassword } from "../../api/login";
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  components: {},

  data() {
    const validatePass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("密码错误，请重新输入"));
      } else {
        callback();
      }
    };
    return {
      formData: {},
      formRules: {
        oldPassWord: [
          {
            required: true,
            message: "请输入旧密码",
            trigger: ["blur", "change"]
          }
        ],
        newPassWord: [
          {
            required: true,
            message: "请输入新密码",
            trigger: ["blur", "change"]
          },
          {
            validator: validatePass,
            trigger: "blur"
          }
        ],
        confirmPassWord: [
          {
            required: true,
            message: "请输入再次确认密码",
            trigger: "change"
          },
          {
            validator: validatePass,
            trigger: "blur"
          }
        ]
      }
    };
  },

  //监听属性
  computed: {
    userInfo() {
      let userMsg = JSON.parse(window.localStorage.getItem("userInfo"));
      return userMsg;
    }
  },
  //监控data中的数据变化

  watch: {},

  //实例期
  created() {},
  //方法集合
  methods: {
    closeFn() {
      this.formData = {};
      this.$emit("close");
    },
    submitFn() {
      console.log(this.userId);
    },
    editPassword() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const params = {
            ...this.formData
          };
          if (params.newPassWord != params.confirmPassWord) {
            this.$message.error("确认密码和新密码不一致");
            return;
          }
          changePassword(params).then(res => {
            if (res.code == 200) {
              this.$message.success("修改成功");
              this.closeFn();
              this.$confirm("请重新登录", "确定登出", {
                confirmButtonText: "重新登录",
                showCancelButton: false,
                type: "warning"
              }).then(() => {
                this.logout();
              });
            }
          });
        }
      });
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    }
  },
  //挂载完成
  mounted() {},

  destroyed() {} //生命周期 - 销毁完成
};
</script>

<style lang='scss' scoped>
.el-input,
.el-select {
  width: 270px;
}
</style>


// WEBPACK FOOTER //
// src/components/loginDialog/index.vue